export default __webpack_public_path__ + "static/miraes-quick-c7088382206b2f13af1321b4a4871928.avif";